// extracted by mini-css-extract-plugin
module.exports = {"container":"PageNotFound_container__y_zG9","text":"PageNotFound_text__g54tH","hashtag":"PageNotFound_hashtag__ng0Yy"};